/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Данные для добавления комитета.
 */
export interface AddCommitteeUsers { 
    /**
     * ID комитета.
     */
    committeeId?: string;
    /**
     * Список участников комитета.
     */
    sendTo?: Array<string>;
}

